export default __webpack_public_path__ + "static/media/Apresentacao_MakersUnit_2024.800937c2.pdf";